<nz-layout [style.width]="(!!readonly ? 660 : 750)  + 'px'">
	<projects-profiles-volume *ngIf="!!root.id" [root]="root" [regular]="false" [readonly]="readonly"
		(onVolumeSelectedChange)="onVolumeSelectedChange($event)" (onVolumeChange)="onVolumeListChange($event)"
		(onFileSynced)="onFileSynced()">
	</projects-profiles-volume>
</nz-layout>
<nz-layout [style.width]="'calc(100% - ' + (!!readonly ? 660 : 750) + 'px)'">
	<nz-content class="table-container">
		<div class="table-wrapper" (scroll)="onScroll($event)" (scrollend)="onScrollEnd($event)" #scroll>
			<table-pro [config]="config!" [currentPage]="pager.pageIndex" [currentPageSize]="pager.pageSize"
				[tableData]="[]" (calcResultChange)="calcResultChange($event)"
				(queryPanelStateChange)="queryPanelStateChange($event)" (resetClick)="resetSearch($event)"
				(searchClick)="searchClick($event)" (checkChange)="checkChange($event)" [stickyTop]="40"
				(afterEdit)="afterEdit($event)">
				<div class="grid overview">
					<div class="row">
						<div class="column no-border color-danger text-left" [style.width]="'10rem'">
							<input type="checkbox" [(ngModel)]="showNotArchivingFile" (ngModelChange)="searchRecord()"
								[disabled]="readonly">
							显示未归卷：{{root.notArchivingFileCount}}份
						</div>
						<div class="column no-border color-primary" [style.width]="'40rem'"
							[style.justifyContent]="'flex-start'">
							<nz-cascader [nzOptions]="unitTreeNodes" [(ngModel)]="unitCascaderValue"
								[nzAllowClear]="false" [nzShowSearch]="true" nzPlaceHolder="请选择WBS部位，不选择则默认为本卷对应WBS工程部位"
								(ngModelChange)="onUnitCascaderValueChange()">
							</nz-cascader>
						</div>
						<div class="action-bar" [style.width]="'20rem'">
							<div class="cell">
								<nz-input-group [nzPrefix]="prefixTemplateUser" nzSearch [nzAddOnAfter]="suffixButton">
									<input type="text" nz-input placeholder="请输入WBS编码" [(ngModel)]="searchWbsCode" />
								</nz-input-group>
								<ng-template #prefixTemplateUser> <span class="color-primary">WBS编码：</span>
								</ng-template>
								<ng-template #suffixButton>
									<button nz-button nzType="primary" nzSearch (click)="searchRecord()">查询</button>
									<button nz-button nzSearch (click)="clearWbsCode()">重置</button>
								</ng-template>
							</div>
						</div>
						<!-- <div class="column no-border color-primary left-sticky" [style.width]="'10rem'">
							<button class="color-primary" nz-button nzType="text" (click)="uploadOfflineVolume()">+
								线下案卷(扫描件)</button>
						</div>
						<div class="column no-border color-primary left-sticky" [style.width]="'10rem'">
							<button class="color-primary" nz-button nzType="text" (click)="downloadVolumeTemp()">↓
								案卷目录模板</button>
						</div> -->
					</div>
				</div>

				<div body>
					<table [style.left]="0" [style.width]="totalWidth + 'px'">
						<colgroup>
							<col span="1" *ngFor="let item of config?.columns ?? []"
								[style.width]="(item.width * 100 / totalWidth) + '%'">
						</colgroup>
						<tr *ngFor="let item of recordTable ?? []; let index = index;">
							<td class="border-bottom-black background-white"
								*ngIf="(item.dwCode || item.sectionItemIndex! === 0) && sliceCount === 0"
								[rowSpan]="item.dwSpan ?? 1">
								<span class="color-light">{{item.dwCode}}</span> {{item.dwName}}
							</td>
							<td class="border-bottom-black background-white"
								*ngIf="(item.subDwCode || item.sectionItemIndex! === 1) && sliceCount <= 1"
								[rowSpan]="item.subDwSpan ?? 1">
								<span class="color-light">{{item.subDwCode}}</span> {{item.subDwName}}
							</td>
							<td class="border-bottom-black background-white"
								*ngIf="(item.fbCode || item.sectionItemIndex! === 2) && sliceCount <= 2"
								[rowSpan]="item.fbSpan ?? 1">
								<span class="color-light">{{item.fbCode}}</span> {{item.fbName}}
							</td>
							<td class="border-bottom-black background-white"
								*ngIf="(item.subFbCode || item.sectionItemIndex! === 3) && sliceCount <= 3"
								[rowSpan]="item.subFbSpan ?? 1">
								<span class="color-light">{{item.subFbCode}}</span> {{item.subFbName}}
							</td>
							<td class="border-bottom-black background-white"
								*ngIf="(item.fxCode || item.sectionItemIndex! === 4) && sliceCount <= 4"
								[rowSpan]="item.fxSpan ?? 1">
								<span class="color-light">{{item.fxCode}}</span> {{item.fxName}}
							</td>
							<td class="background-white border-bottom-black"
								*ngIf="(item.sectionCode || item.sectionItemIndex! === 5) && sliceCount <= 5"
								[rowSpan]="item.sectionSpan ?? 1">
								<p *ngIf="!!item.sectionCode" class="ellipsis" dPopover
									[content]="item.sectionCode + ' ' + item.sectionName" [trigger]="'hover'"
									[position]="['bottom','top', 'right',  'left']"
									[controlled]="!!item.sectionName && item.sectionName.length > 16"
									[popoverStyle]="{ backgroundColor: 'white', color: '#2b58cd' }"
									[appendToBody]="true">
									<span class="color-grey">{{item.sectionCode}}</span> {{item.sectionName}}
								</p>
							</td>
							<td class="text-center background-white border-bottom-black"
								*ngIf="isLM && item.segmentCode" [rowSpan]="item.segmentSpan ?? 1">
								{{item.segmentCode}}
							</td>
							<td class="text-center background-white border-bottom-black"
								*ngIf="isLJ && item.partitionCode" [rowSpan]="item.partitionSpan ?? 1">
								{{item.partitionCode}}
							</td>
							<td class="text-center background-white border-bottom-black" *ngIf="isLJ && item.layerCode"
								[rowSpan]="item.layerSpan ?? 1">
								{{item.layerCode}}
							</td>
							<td class="background-white border-bottom-black text-center {{!readonly ? 'editable' : ''}}"
								*ngIf="item.isFakeFile || index === 0"
								[rowSpan]="isLJ ? item.layerSpan ?? 1 : isLM ? item.segmentSpan ?? 1 : item.sectionSpan ?? 1">
								<format-data class="{{!item.volumeIdTarget ? 'color-danger' : 'color-primary'}}"
									[contentStr]="!!item.volumeIdTarget && volumeMap[item.volumeIdTarget] ? volumeMap[item.volumeIdTarget].sortOrderLabel!  : '未归卷'">
									<select class="transparent" [(ngModel)]="item.volumeIdTarget" *ngIf="!readonly"
										(ngModelChange)="onSortOrderChange(item)">
										<option *ngFor="let volume of volumeSortOrderOpts" [value]="volume.value">
											{{volume.label}}
										</option>
									</select>
								</format-data>
							</td>
							<td class="background-white border-bottom-black text-center color-primary {{ArchiveFileGroupStatus.COMPLETE === item.status ? 'color-success' : 'color-danger'}}"
								*ngIf="item.isFakeFile || index === 0"
								[rowSpan]="isLJ ? item.layerSpan ?? 1 : isLM ? item.segmentSpan ?? 1 : item.sectionSpan ?? 1">
								{{ArchiveFileGroupStatusMap[item.status!]}}
							</td>
							<td *ngIf="item.isFakeFile" [attr.colspan]="readonly ? 3 : 4" (click)="expandToggle(index)">
								<span class="color-light icon-toggle" nz-icon
									[nzType]="!item.expended ? 'caret-right' : 'caret-down'" nzTheme="outline"></span>
								<span
									class="{{item.fileStatusStatisticsLabel === 'OK' ? 'color-success' : 'color-danger'}}">{{item.fileCount}}个文件({{item.filePageCount}}页):{{item.fileStatusStatisticsLabel}}</span>
							</td>
							<td *ngIf="item.isFakeFile" colspan="3" class="{{readonly ? '' : 'editable'}}">
								<format-data [contentStr]="item.title ?? ''" [patternStr]="'E+200'"
									(click)="editColumn('title' + index)">
									<input *ngIf="!readonly" type="text" [(ngModel)]="item.title"
										class="{{editing['title' + index] || item.title === undefined || item.title + '' === ''? '' : 'transparent'}}"
										(blur)="onGroupEdit(item)" />
								</format-data>
							</td>
							<td *ngIf="!item.isFakeFile"
								class="{{item.fileInfo?.volumeFileSortOrderTarget !== undefined && !readonly ? 'editable' : ''}}"
								[style.textAlign]="'center'">
								<span *ngIf="item.fileInfo?.volumeFileSortOrderTarget === undefined || readonly">
									{{item.fileIndexTarget!}}
								</span>

								<!-- <select *ngIf="item.fileInfo?.volumeFileSortOrderTarget !== undefined && !readonly"
									[style.appearance]="'none'" [style.textAlign]="'center'"
									[(ngModel)]="item.fileInfo!.volumeFileSortOrderTarget"
									(ngModelChange)="onSortFileOrderChange(item.fileInfo)">
									<option *ngFor="let item of currentFileOrderOpts" [value]="item.value">
										{{item.label}}
									</option>
								</select> -->

								<input
									*ngIf="item.fileInfo?.volumeFileSortOrderTarget !== undefined && item.volumeId && !readonly"
									type="text" [(ngModel)]="item.fileIndexTarget" [style.textAlign]="'center'"
									(blur)="onSortFileOrderChangeByIndex(item)" appDigitalFormat>
							</td>
							<td *ngIf="!item.isFakeFile" class="clickable color-primary"
								(click)="sign(item.fileInfo?.workFlowKey)">
								<format-data *ngIf="item.fileInfo" [patternStr]="'E+310'"
									[contentStr]="item.fileInfo.formTitle">
								</format-data>
							</td>
							<td class="{{readonly ? '' : 'editable'}}" *ngIf="!item.isFakeFile">
								<nz-date-picker *ngIf="item.fileInfo" [(ngModel)]="item.fileInfo.finishDateDate"
									[nzSuffixIcon]="''" [nzFormat]="'yyyy-MM-dd'" [nzPlaceHolder]="' '"
									[nzDisabled]="readonly" (ngModelChange)="onFileEdit(item.fileInfo)">
								</nz-date-picker>
							</td>
							<td class="{{item.fileInfo?.fileStatus !== ArchiveFileStatus.OK && item.fileInfo?.fileStatus !== ArchiveFileStatus.ERROR && item.fileInfo?.fileStatus !== ArchiveFileStatus.UPDATE || readonly ? '' : 'editable'}}"
								*ngIf="!item.isFakeFile">

								<format-data *ngIf="item.fileInfo && item.fileInfo.fileStatus && !readonly"
									class="{{item.fileInfo.fileStatus === ArchiveFileStatus.OK ? 'color-success' : 'color-danger'}}"
									[contentStr]="ArchiveFileStatusMap[item.fileInfo.fileStatus!]">
									<select [(ngModel)]="item.fileInfo.fileStatus"
										(ngModelChange)="onFileEdit(item.fileInfo)" [style.appearance]="'none'"
										[disabled]="item.fileInfo.fileStatus !== ArchiveFileStatus.OK && item.fileInfo.fileStatus !== ArchiveFileStatus.ERROR && item.fileInfo.fileStatus !== ArchiveFileStatus.UPDATE"
										class="transparent">
										<option [value]="ArchiveFileStatus.OK">
											{{ ArchiveFileStatusMap[ArchiveFileStatus.OK] }}
										</option>
										<option [value]="ArchiveFileStatus.ERROR">
											{{ ArchiveFileStatusMap[ArchiveFileStatus.ERROR] }}
										</option>
										<option [value]="ArchiveFileStatus.UPDATE" [disabled]="true">
											{{ ArchiveFileStatusMap[ArchiveFileStatus.UPDATE] }}
										</option>
									</select>
								</format-data>

								<span *ngIf="readonly && item.fileInfo && item.fileInfo.fileStatus"
									class="{{item.fileInfo.fileStatus === ArchiveFileStatus.OK ? 'color-success' : 'color-danger'}}">
									{{ ArchiveFileStatusMap[item.fileInfo.fileStatus] }}
								</span>
							</td>
							<td class="{{readonly ? '' : 'editable'}}" *ngIf="!item.isFakeFile">
								<input *ngIf="!readonly && item.fileInfo" class="color-danger" type="text"
									[(ngModel)]="item.fileInfo.comment" (blur)="onFileEdit(item.fileInfo)" />

								<format-data *ngIf="!!readonly && item.fileInfo" class="clickable color-primary"
									[contentStr]="item.fileInfo.comment ?? ''" [patternStr]="'E+120'">
								</format-data>
							</td>
							<td *ngIf="!item.isFakeFile && !readonly">
								<div class="line" *ngIf="!!item.fileInfo">
									<span
										class="fake-btn {{!item.fileInfo.volumeId || !item.fileInfo.volumeFileId || !volumeMap[item.fileInfo.volumeId] || volumeMap[item.fileInfo.volumeId].status !== ArchiveStatus.UNLOCK ? 'color-light' : 'color-primary'}}"
										(click)="moveUp(item.fileInfo, index - item.fileIndex! - 1)">
										↑
									</span>
									<span
										class="fake-btn {{!item.fileInfo.volumeId || !item.fileInfo.volumeFileId || !volumeMap[item.fileInfo.volumeId] || volumeMap[item.fileInfo.volumeId].status !== ArchiveStatus.UNLOCK ? 'color-light' : 'color-primary'}}"
										(click)="moveDown(item.fileInfo, index - item.fileIndex! - 1)">
										↓
									</span>
									<span
										class="fake-btn {{!item.fileInfo.volumeId || !item.fileInfo.volumeFileId || !volumeMap[item.fileInfo.volumeId] || volumeMap[item.fileInfo.volumeId].status !== ArchiveStatus.UNLOCK ? 'color-light' : 'color-primary'}}">
										+
										<input type="file"
											[disabled]="!item.fileInfo.volumeId || !item.fileInfo.volumeFileId || !volumeMap[item.fileInfo.volumeId] || volumeMap[item.fileInfo.volumeId].status !== ArchiveStatus.UNLOCK"
											(change)="insertFile($event,item.fileInfo, index - item.fileIndex! - 1)"
											accept=".pdf">
									</span>
									<span class="fake-btn color-primary"
										(click)="remove(item.fileInfo, index - item.fileIndex! - 1)">
										{{item.fileInfo?.recordSource === RecordSource.MANUAL ? '删除' : '移除'}}
									</span>
								</div>
							</td>
							<td *ngIf="!item.isFakeFile">
								<span>{{item.fileInfo!.filePageCount}}</span>｜<span
									class="color-grey">{{item.fileInfo!.attachFileCount}}-{{item.fileInfo!.attachFilePageCount}}</span>｜<span>{{(+item.fileInfo!.fileSize!
									+ +item.fileInfo!.attachFileSize!) | fileSize}}</span>
							</td>
						</tr>
					</table>
					<table class="fake {{scrollIndex % 2 === 1 ? 'odd' : ''}}" *ngIf="recordFakeTable.length > 0"
						[style.left]="0" [style.width]="totalWidth + 'px'"
						[style.top]="(scrollTop + (isOpen ? 136 : 72)) + 'px'">
						<colgroup>
							<col span="1" *ngFor="let item of config?.columns ?? []"
								[style.width]="(item.width * 100 / totalWidth) + '%'">
						</colgroup>
						<tr *ngFor="let item of recordFakeTable; let index = index;">

							<td class="border-bottom-black background-white"
								*ngIf="(item.dwCode || item.sectionItemIndex! === 0) && sliceCount === 0"
								[rowSpan]="item.dwSpan ?? 1">
								<span class="color-light">{{item.dwCode}}</span> {{item.dwName}}
							</td>
							<td class="border-bottom-black background-white"
								*ngIf="(item.subDwCode || item.sectionItemIndex! === 1) && sliceCount <= 1"
								[rowSpan]="item.subDwSpan ?? 1">
								<span class="color-light">{{item.subDwCode}}</span> {{item.subDwName}}
							</td>
							<td class="border-bottom-black background-white"
								*ngIf="(item.fbCode || item.sectionItemIndex! === 2) && sliceCount <= 2"
								[rowSpan]="item.fbSpan ?? 1">
								<span class="color-light">{{item.fbCode}}</span> {{item.fbName}}
							</td>
							<td class="border-bottom-black background-white"
								*ngIf="(item.subFbCode || item.sectionItemIndex! === 3) && sliceCount <= 3"
								[rowSpan]="item.subFbSpan ?? 1">
								<span class="color-light">{{item.subFbCode}}</span> {{item.subFbName}}
							</td>
							<td class="border-bottom-black background-white"
								*ngIf="(item.fxCode || item.sectionItemIndex! === 4) && sliceCount <= 4"
								[rowSpan]="item.fxSpan ?? 1">
								<span class="color-light">{{item.fxCode}}</span> {{item.fxName}}
							</td>
							<td class="background-white border-bottom-black"
								*ngIf="(item.sectionCode || item.sectionItemIndex! === 5) && sliceCount <= 5"
								[rowSpan]="item.sectionSpan ?? 1">
								<p *ngIf="!!item.sectionCode" class="ellipsis" dPopover
									[content]="item.sectionCode + ' ' + item.sectionName" [trigger]="'hover'"
									[position]="['bottom','top', 'right',  'left']"
									[controlled]="!!item.sectionName && item.sectionName.length > 16"
									[popoverStyle]="{ backgroundColor: 'white', color: '#2b58cd' }"
									[appendToBody]="true">
									<span class="color-grey">{{item.sectionCode}}</span> {{item.sectionName}}
								</p>
							</td>
							<td class="text-center background-white border-bottom-black"
								*ngIf="isLM && item.segmentCode" [rowSpan]="item.segmentSpan ?? 1">
								{{item.segmentCode}}
							</td>
							<td class="text-center background-white border-bottom-black"
								*ngIf="isLJ && item.partitionCode" [rowSpan]="item.partitionSpan ?? 1">
								{{item.partitionCode}}
							</td>
							<td class="text-center background-white border-bottom-black" *ngIf="isLJ && item.layerCode"
								[rowSpan]="item.layerSpan ?? 1">
								{{item.layerCode}}
							</td>
							<td class="background-white border-bottom-black text-center {{!readonly ? 'editable' : ''}}"
								*ngIf="item.isFakeFile || index === 0"
								[rowSpan]="isLJ ? item.layerSpan ?? 1 : isLM ? item.segmentSpan ?? 1 : item.sectionSpan ?? 1">
								<format-data class="{{!item.volumeIdTarget ? 'color-danger' : 'color-primary'}}"
									[contentStr]="!!item.volumeIdTarget && volumeMap[item.volumeIdTarget] ? volumeMap[item.volumeIdTarget].sortOrderLabel!  : '未归卷'">
									<select class="transparent" [(ngModel)]="item.volumeIdTarget" *ngIf="!readonly"
										[style.appearance]="'none'" (ngModelChange)="onSortOrderChange(item)">
										<option *ngFor="let volume of volumeSortOrderOpts" [value]="volume.value">
											{{volume.label}}
										</option>
									</select>
								</format-data>
							</td>
							<td class="background-white border-bottom-black text-center color-primary {{ArchiveFileGroupStatus.COMPLETE === item.status ? 'color-success' : 'color-danger'}}"
								*ngIf="item.isFakeFile || index === 0"
								[rowSpan]="isLJ ? item.layerSpan ?? 1 : isLM ? item.segmentSpan ?? 1 : item.sectionSpan ?? 1">
								{{ArchiveFileGroupStatusMap[item.status!]}}
							</td>
							<td *ngIf="item.isFakeFile" [attr.colspan]="readonly ? 3 : 4"
								(click)="expandToggle(index + scrollIndex)">
								<span class="color-light icon-toggle" nz-icon
									[nzType]="!item.expended ? 'caret-right' : 'caret-down'" nzTheme="outline"></span>
								<span
									class="{{item.fileStatusStatisticsLabel === 'OK' ? 'color-success' : 'color-danger'}}">{{item.fileCount}}个文件({{item.filePageCount}}页):{{item.fileStatusStatisticsLabel}}</span>
							</td>
							<td *ngIf="item.isFakeFile" colspan="3" class="{{readonly ? '' : 'editable'}}">
								<format-data [contentStr]="item.title ?? ''" [patternStr]="'E+200'"
									(click)="editColumn('title' + index + scrollIndex)">
									<input *ngIf="!readonly" type="text" [(ngModel)]="item.title"
										class="{{editing['title' + index + scrollIndex] || item.title === undefined || item.title + '' === ''? '' : 'transparent'}}"
										(blur)="onGroupEdit(item)" />
								</format-data>
							</td>
							<td *ngIf="!item.isFakeFile"
								class="{{item.fileInfo?.volumeFileSortOrderTarget !== undefined && !readonly ? 'editable' : ''}}"
								[style.textAlign]="'center'">
								<span *ngIf="item.fileInfo?.volumeFileSortOrderTarget === undefined || readonly">
									{{item.fileIndexTarget!}}
								</span>

								<!-- <select *ngIf="item.fileInfo?.volumeFileSortOrderTarget !== undefined && !readonly"
									[style.appearance]="'none'" [style.textAlign]="'center'"
									[(ngModel)]="item.fileInfo!.volumeFileSortOrderTarget"
									(ngModelChange)="onSortFileOrderChange(item.fileInfo)">
									<option *ngFor="let item of currentFileOrderOpts" [value]="item.value">
										{{item.label}}
									</option>
								</select> -->

								<input
									*ngIf="item.fileInfo?.volumeFileSortOrderTarget !== undefined && item.volumeId && !readonly"
									type="text" [(ngModel)]="item.fileIndexTarget" [style.textAlign]="'center'"
									(blur)="onSortFileOrderChangeByIndex(item)" appDigitalFormat>
							</td>
							<td *ngIf="!item.isFakeFile" class="clickable color-primary"
								(click)="sign(item.fileInfo?.workFlowKey)">
								<format-data *ngIf="item.fileInfo" [patternStr]="'E+310'"
									[contentStr]="item.fileInfo.formTitle">
								</format-data>
							</td>
							<td class="{{readonly ? '' : 'editable'}}" *ngIf="!item.isFakeFile">
								<nz-date-picker *ngIf="item.fileInfo" [(ngModel)]="item.fileInfo.finishDateDate"
									[nzSuffixIcon]="''" [nzFormat]="'yyyy-MM-dd'" [nzPlaceHolder]="' '"
									[nzDisabled]="readonly" (ngModelChange)="onFileEdit(item.fileInfo)">
								</nz-date-picker>
							</td>
							<td class="{{item.fileInfo?.fileStatus !== ArchiveFileStatus.OK && item.fileInfo?.fileStatus !== ArchiveFileStatus.ERROR && item.fileInfo?.fileStatus !== ArchiveFileStatus.UPDATE || readonly ? '' : 'editable'}}"
								*ngIf="!item.isFakeFile">
								<format-data *ngIf="item.fileInfo && item.fileInfo.fileStatus && !readonly"
									class="{{item.fileInfo.fileStatus === ArchiveFileStatus.OK ? 'color-success' : 'color-danger'}}"
									[contentStr]="ArchiveFileStatusMap[item.fileInfo.fileStatus!]">
									<select [(ngModel)]="item.fileInfo.fileStatus"
										(ngModelChange)="onFileEdit(item.fileInfo)" [style.appearance]="'none'"
										[disabled]="item.fileInfo.fileStatus !== ArchiveFileStatus.OK && item.fileInfo.fileStatus !== ArchiveFileStatus.ERROR && item.fileInfo.fileStatus !== ArchiveFileStatus.UPDATE"
										class="transparent">
										<option [value]="ArchiveFileStatus.OK">
											{{ ArchiveFileStatusMap[ArchiveFileStatus.OK] }}
										</option>
										<option [value]="ArchiveFileStatus.ERROR">
											{{ ArchiveFileStatusMap[ArchiveFileStatus.ERROR] }}
										</option>
										<option [value]="ArchiveFileStatus.UPDATE" [disabled]="true">
											{{ ArchiveFileStatusMap[ArchiveFileStatus.UPDATE] }}
										</option>
									</select>
								</format-data>

								<span *ngIf="readonly && item.fileInfo && item.fileInfo.fileStatus"
									class="{{item.fileInfo.fileStatus === ArchiveFileStatus.OK ? 'color-success' : 'color-danger'}}">
									{{ ArchiveFileStatusMap[item.fileInfo.fileStatus] }}
								</span>
							</td>
							<td class="{{readonly ? '' : 'editable'}}" *ngIf="!item.isFakeFile">
								<input *ngIf="!readonly && item.fileInfo" class="color-danger" type="text"
									[(ngModel)]="item.fileInfo.comment" (blur)="onFileEdit(item.fileInfo)" />

								<format-data *ngIf="!!readonly && item.fileInfo" class="clickable color-primary"
									[contentStr]="item.fileInfo.comment ?? ''" [patternStr]="'E+120'">
								</format-data>
							</td>
							<td *ngIf="!item.isFakeFile && !readonly">
								<div class="line" *ngIf="!!item.fileInfo">
									<span
										class="fake-btn {{!item.fileInfo.volumeId || !item.fileInfo.volumeFileId || !volumeMap[item.fileInfo.volumeId] || volumeMap[item.fileInfo.volumeId].status !== ArchiveStatus.UNLOCK ? 'color-light' : 'color-primary'}}"
										(click)="moveUp(item.fileInfo, index + scrollIndex - item.fileIndex! - 1)">
										↑
									</span>
									<span
										class="fake-btn {{!item.fileInfo.volumeId || !item.fileInfo.volumeFileId || !volumeMap[item.fileInfo.volumeId] || volumeMap[item.fileInfo.volumeId].status !== ArchiveStatus.UNLOCK ? 'color-light' : 'color-primary'}}"
										(click)="moveDown(item.fileInfo, index + scrollIndex - item.fileIndex! - 1)">
										↓
									</span>
									<span
										class="fake-btn {{!item.fileInfo.volumeId || !item.fileInfo.volumeFileId || !volumeMap[item.fileInfo.volumeId] || volumeMap[item.fileInfo.volumeId].status !== ArchiveStatus.UNLOCK ? 'color-light' : 'color-primary'}}">
										+
										<input type="file"
											[disabled]="!item.fileInfo.volumeId || !item.fileInfo.volumeFileId || !volumeMap[item.fileInfo.volumeId] || volumeMap[item.fileInfo.volumeId].status !== ArchiveStatus.UNLOCK"
											(change)="insertFile($event,item.fileInfo, index + scrollIndex - item.fileIndex! - 1)"
											accept=".pdf">
									</span>
									<span class="fake-btn color-primary"
										(click)="remove(item.fileInfo, index + scrollIndex - item.fileIndex! - 1)">
										{{item.fileInfo?.recordSource === RecordSource.MANUAL ? '删除' : '移除'}}
									</span>
								</div>
							</td>
							<td *ngIf="!item.isFakeFile">
								<span>{{item.fileInfo!.filePageCount}}</span>｜<span
									class="color-grey">{{item.fileInfo!.attachFileCount}}-{{item.fileInfo!.attachFilePageCount}}</span>｜<span>{{(+item.fileInfo!.fileSize!
									+ +item.fileInfo!.attachFileSize!) | fileSize}}</span>
							</td>
						</tr>

					</table>
				</div>

			</table-pro>
		</div>
	</nz-content>
	<nz-footer class="footer">
		<nz-pagination class="footer-left" [nzPageIndex]="pager.pageIndex" [(nzPageSize)]="pager.pageSize"
			[nzPageSizeOptions]="pager.pageSizeOptions" [nzTotal]="pager.total" nzShowQuickJumper
			[nzShowSizeChanger]="true" [nzShowQuickJumper]="true" (nzPageIndexChange)="pageIndexChange($event)"
			(nzPageSizeChange)="pageSizeChange($event)">
		</nz-pagination>
	</nz-footer>
</nz-layout>



<ng-template appHost></ng-template>